function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgStarHalfFilled = function SvgStarHalfFilled(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Half Filled Star' : _ref$title,
      stroke = _ref.stroke,
      dir = _ref.dir,
      props = _objectWithoutProperties(_ref, ["title", "stroke", "dir"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 46 44"
  }, dir === 'rtl' ? {
    transform: 'scale(-1, 1)'
  } : {}), React.createElement("path", {
    stroke: stroke,
    strokeWidth: 3,
    d: "M23 0l7.053 14.292 15.772 2.292-11.412 11.124 2.694 15.708L23 36 8.893 43.416l2.694-15.708L.175 16.584l15.772-2.292L23 0zm0 4v29.85L34.743 40 32.5 26.975l9.5-9.224-13.129-1.9L23 4z"
  }), React.createElement("polygon", {
    fill: "#FFF",
    strokeWidth: 3,
    stroke: stroke,
    points: "22.8253564 36 22.8253564 2.34479103e-13 29.8787794 14.2917961 45.6507128 16.5835921 34.2380346 27.7082039 36.9322024 43.4164079"
  }));
};

SvgStarHalfFilled = pure(SvgStarHalfFilled);
SvgStarHalfFilled.displayName = 'SvgStarHalfFilled';
export default SvgStarHalfFilled;